module.exports = __webpack_public_path__ + "static/media/Combles_amenages_ChTradi_Suspente_RT_RTmax18_HD_01.3809dcf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Combles_amenages_ChTradi_Suspente_RT_RTmax18_HD_01.jpg
// module id = 1144
// module chunks = 0